export type AgencyProviderModel = {
  agency_id: number,
  cache_key: string,
  id: number,
  identity_code: string,
  provider_id: number,
  provider_price_list_id?: number,
  publication_id: number,
  service_id: number,
}

export type AgencyProviderRequestOptions = {}

const state = {
  agency_id: undefined,
  id: null,
  identity_code: '',
  provider_id: undefined,
  provider_price_list_id: undefined,
  service_id: undefined,
}

export const requiredFields = [
  { key: 'agency_id' },
  { key: 'provider_id' },
  { key: 'service_id' },
]

export default state
